<template>
    <v-container fluid>
        <v-row no-gutters class="d-block">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                    <v-card-title>
                        <v-row>

                            <v-col cols="6" sm="4" md="2" lg="2" xl="2">
                                <v-btn color="success" v-if="permisos[2]" small outlined @click="personaNuevo()">
                                    <v-icon>add</v-icon>
                                    Nuevo
                                </v-btn>
                            </v-col>

                            <v-col cols="6" sm="4" md="2" lg="2" xl="2">
                                <v-btn color="info" small outlined @click="personasGet()">
                                    <v-icon>refresh</v-icon>
                                    Refrescar
                                </v-btn>
                            </v-col>

                            <v-col cols="6" sm="4" md="3" lg="3" xl="3">
                                <v-btn color="success" small outlined v-if="permisos[2]" @click="generarCredenciales(false)">
                                    <v-icon>key</v-icon>
                                    Gen. Credenciales
                                </v-btn>
                            </v-col>

                            <v-col cols="12" class="pt-0">
                                <buscador-campos
                                    ref="buscador"
                                    :campos="camposBusqueda"
                                    sugerir-personas
                                    :tipo-persona="3"
                                    :cargando="loading"
                                    @buscar="buscar"
                                    @limpiar="buscar({texto: '', campo: 'todos', persona: null})"
                                />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            dense
                            class="elevation-3"
                            :headers="tableHeaders"
                            :items="personas"
                            :loading="loading"
                            item-key="persona_id"
                            fixed-header
                            height="65vh"
                            :hide-default-footer="true"
                            disable-pagination
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left text-no-wrap" v-html="resaltar(item.numero_identidad, 'identidad')"></td>
                                    <td class="text-left" v-html="resaltar(item.nombre, 'nombre')"></td>
                                    <td class="text-left" v-html="resaltar(item.apellido, 'nombre')"></td>
                                    <td class="text-left">{{ item.correo }}</td>
                                    <td class="text-left">{{ item.telefono }}</td>
                                    <td class="text-left">{{ item.ciudad }}</td>
                                    <td class="text-left">{{ item.direccion }}</td>
                                    <td class="text-center">
                                        <v-btn color="info" small outlined @click="personasEdit(item)" title="Editar" v-if="permisos[3]">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                <v-alert dense type="warning" outlined class="text-center mt-3">
                                    No existen registros.
                                </v-alert>
                            </template>
                        </v-data-table>
                        <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina"
                                    v-if="pagination.total"/>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="showModalGenerar"
            persistent
            max-width="520">
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    <v-icon left color="primary">key</v-icon>
                    Generando credenciales de estudiantes
                </v-card-title>

                <v-card-text>
                    <p class="mb-3">No cierre esta ventana. Se generan por lotes y lo avanzado queda guardado.</p>
                    <v-progress-linear
                        :indeterminate="!credenciales.total"
                        :value="credenciales.total ? (credenciales.generadas * 100) / credenciales.total : 0"
                        height="10" rounded
                        color="success"
                    ></v-progress-linear>
                    <div class="text-caption grey--text text--darken-1 mt-2" v-if="credenciales.total">
                        {{ credenciales.generadas }} de {{ credenciales.total }} · faltan {{ credenciales.pendientes }}
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import Auth from "@/services/auth";
import {generarCredencialesEstudiantes} from "@/services/credenciales";
const Pagination = () => import("@/pages/Components/Pagination.vue");
import BuscadorCampos, {CAMPOS_PERSONAS} from "@/components/Buscador/BuscadorCampos.vue";

export default {
    name: 'ParticipantesEstudiantesLista',
    components: {Pagination, BuscadorCampos},
    data() {
        return {
            permisos: [],
            personas: [],
            pagination: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            search: "",
            campo: "todos",
            secuenciaConsulta: 0,
            camposBusqueda: CAMPOS_PERSONAS,
            loading: false,
            showModalGenerar: false,
            credenciales: {generadas: 0, pendientes: 0, total: 0},
            filtros: {
                cat_tipo_persona_id: 3
            },
            tableHeaders: [
                {
                    text: 'N.° Identidad',
                    value: 'numero_identidad',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Nombres',
                    value: 'nombre',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Apellidos',
                    value: 'apellido',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Correo',
                    value: 'correo',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Teléfono',
                    value: 'telefono',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Ciudad',
                    value: 'ciudad',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Dirección',
                    value: 'direccion',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Acciones',
                    align: 'center',
                    sortable: false
                },
            ],
        }
    },
    methods: {
        personaNuevo() {
            this.$router.push({name: 'ParticipantesEstudiantesNuevo'});
        },
        buscar(criterio) {
            this.search = criterio.texto;
            this.campo = criterio.campo;
            // Participante elegido en las sugerencias: se busca por su identidad exacta.
            if (criterio.participante) {
                this.search = criterio.participante.numero_identidad;
                this.campo = "identidad";
            }
            this.pageActual = 1;
            this.personasGet();
        },
        resaltar(valor, columna) {
            const buscador = this.$refs.buscador;
            return buscador ? buscador.resaltar(valor, columna) : (valor || "");
        },
        personasBuscar() {
            this.pageActual = 1;
            this.personasGet();
        },
        personasGet() {
            this.loading = true;
            const secuencia = ++this.secuenciaConsulta;
            let params = {filtros: this.filtros, busqueda: this.search, campo: this.campo, page: this.pageActual, rowsPage: this.rowsPage};
            window.axios.get('/personas', {params}).then(response => {
                if (secuencia !== this.secuenciaConsulta) return;
                if (response.data.success) {
                    let data = response.data.data;
                    this.personas = data.personas.data;
                    this.pagination = data.pagination;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        personasEdit(persona) {
            if (typeof persona == "object") {
                let token = window.btoa(persona.persona_id);
                this.$router.push({name: 'ParticipantesEstudiantesEditar', query: {token}});
            } else {
                this.$toast.error("Parametro no valido.");
            }
        },
        async generarCredenciales(silencioso = false) {
            this.credenciales = {generadas: 0, pendientes: 0, total: 0};
            this.showModalGenerar = true;

            try {
                const resultado = await generarCredencialesEstudiantes(estado => {
                    this.credenciales = estado;
                });

                if (resultado.generadas) {
                    this.$toast.success(`Se generaron ${resultado.generadas} credenciales de estudiantes.`);
                } else if (!silencioso) {
                    this.$toast.info("Todos los estudiantes ya tienen credenciales.");
                }

                if (resultado.pendientes) {
                    this.$toast.warning(`Quedaron ${resultado.pendientes} pendientes. Pulse de nuevo Gen. Credenciales.`, {timeout: 15000});
                }

                if (resultado.conflictos.length) {
                    const ejemplos = resultado.conflictos.slice(0, 5).map(c => `${c.numero_identidad} (${c.nombre} ${c.apellido})`).join(", ");
                    this.$toast.warning(
                        `${resultado.conflictos.length} estudiantes no recibieron credenciales porque su identidad ya es el usuario de otra cuenta: ${ejemplos}.`,
                        {timeout: false, closeButton: "button"}
                    );
                }
            } catch (error) {
                console.log(error);
                const hechas = this.credenciales.generadas;
                this.$toast.error(
                    hechas
                        ? `Se interrumpió tras generar ${hechas} credenciales. Lo avanzado quedó guardado: pulse de nuevo para continuar.`
                        : "No se pudo generar las credenciales. Intente de nuevo.",
                    {timeout: 15000}
                );
            } finally {
                this.showModalGenerar = false;
            }
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.personasGet();
        },
    },
    created() {
        Auth.checkPermisos(this.$route.path).then((res) => {
            this.permisos = res;
            this.personasGet();
        });
    }
}
</script>

<style>

</style>
